<button class="btn btn-primary mb-1" [disabled]="!isEnabled" (click)="noteTicket()" #button>
    <span class="element-text">{{ 'console.note-ticket' | translate }}</span>
</button>